/* eslint-disable */
<template>
  <div>
    <div class="login">
      <div class="form">
        <div>
          <div class="logo">
            <a href="http://fexspace.com"
              ><img src="../../public/logo-small.png"
            /></a>
          </div>
          <template v-if="name">
            <h3>Welcome, {{ name }}</h3>
          </template>
          <template v-else>
            <h3>Welcome, back</h3>
          </template>
          <!--<p>Sign back in to continue collaborating</p>-->
          <div>
            <p class="text-left" style="margin-bottom: 5px !important">
              Sign in with:
            </p>
            <p class="d-flex justify-content-between">
              <span class="gmail-login" @click="login_pop('gmail')">
                <span>
                  <img src="@/assets/google.png" /> <span>Google</span>
                </span>
                <span>
                  <img
                    src="@/assets/spinner-200px.gif"
                    width="45px"
                    v-if="google_loader"
                  />
                </span>
              </span>
              &nbsp; &nbsp;
              <span class="linked-login" @click="login_pop('linkedin')">
                <span>
                  <img
                    src="@/assets/linkedin.png"
                    class="img-fluid linkedin-img"
                  />
                </span>
                <span>
                  <img
                    src="@/assets/spinner-200px.gif"
                    width="45px"
                    class="loader"
                    v-if="linked_loader"
                  />
                </span>
              </span>
            </p>
          </div>
          <hr />
          <form @keypress="send" @submit.prevent>
            <div class="error-login animated slideInUp" v-if="error.message">
              Login details is incorrect
              <i class="fa fa-times" @click="close"></i>
            </div>
            <div>
              <input
                type="text"
                placeholder="Email address"
                name="email"
                v-model="email"
              />
              <span class="error" v-if="error.email">*Required</span>
            </div>
            <div>
              <input
                :type="[!reveal ? 'password' : 'text']"
                name="password"
                placeholder="Password"
                v-model="password"
              />
              <span class="reveal" @click="reveal_password">
                <i
                  class="fa"
                  :class="{ 'fa-eye': reveal, 'fa-eye-slash': !reveal }"
                ></i>
              </span>
              <span class="error" v-if="error.password">*Required</span>
            </div>
            <div class="keepme">
              <label>
                <input type="checkbox" v-model="keepme" /> Keep Me Logged In
              </label>
              <span>
                <router-link to="/forgot-password"
                  >Forgot Password?</router-link
                >
              </span>
            </div>
            <div>
              <button type="button" @click="submit">Sign In</button>
            </div>
            <div class="dont">
              <p>
                Don't Have An Account?
                <router-link to="/create-account">Sign Up</router-link>
              </p>
            </div>
          </form>
          <div
            class="mfes-trustmark"
            data-type="102"
            data-width="80"
            data-height="33"
          ></div>
        </div>
      </div>
    </div>
    <loading ref="loading"></loading>
  </div>
</template>
<style scoped>
.gmail-login {
  cursor: pointer;
  background: #eee;
  box-shadow: 0px 0px 2px #00000012, 0px 2px 2px #00000024;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  border-radius: 5px;
  width: 50%;
  height: 50px;
}
.gmail-login span {
  font-weight: normal;
  font-size: 15px;
  margin-left: 0.8em;
}
.linked-login {
  box-shadow: 0px 0px 2px #00000012, 0px 2px 2px #00000024;
  cursor: pointer;
  background: #fff;
  display: flex;
  justify-content: center;
  border-radius: 5px;
  align-items: left;
  height: 50px;
  width: 50%;
}
.linked-login span {
  max-width: 105px;
}
.linked-login img.linkedin-img {
  margin-top: 16px;
}
.linked-login .loader {
  margin-top: 0.3em;
}
.login .form form {
  margin-top: 0;
}
.login {
  justify-content: center;
  height: 100vh;
}
</style>
<script>
import AuthenticationService from "@/services/AuthenticationService";
import loading from "@/components/Loading";
import cookies from "@/services/cookies";
import { mapMutations } from "vuex";

export default {
  components: {
    loading,
  },
  data() {
    return {
      reveal: false,
      email: "",
      password: "",
      keepme: false,
      name: "",
      error: {
        email: false,
        password: false,
        message: false,
      },
      post: true,
      linked_loader: false,
      google_loader: false,
    };
  },
  methods: {
    ...mapMutations([
      "SET_DIRECTORY_CHILDREN",
      "SET_IS_SECURITY_QUESTION",
      "SET_HAS_ON_BOARDED",
    ]),
    login_pop(type) {
      if (type === "gmail") {
        this.google_loader = true;
      } else {
        this.linked_loader = true;
      }

      let data = {
        type,
      };

      AuthenticationService.auth(data)
        .then((res) => {
          window.location = res.data.link;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    reveal_password() {
      this.reveal = !this.reveal;
    },
    close() {
      this.error.message = false;
    },
    send(evt) {
      if (evt.keyCode === 13) {
        this.post = true;

        if (this.email === "") {
          this.post = false;
          this.error.email = true;
        } else {
          this.error.email = false;
        }

        if (this.password === "") {
          this.post = false;
          this.error.password = true;
        } else {
          this.error.password = false;
        }

        if (this.post) {
          let that = this;
          this.$refs.loading.load();

          sessionStorage.setItem("keepme", this.keepme);

          let data = {
            email: this.email,
            password: this.password,
          };

          AuthenticationService.login(data)
            .then((res) => {
              if (res.data.data === true) {
                // If your plan type is 1. You are a free user
                localStorage.setItem("hasOnboarded", res.data.hasOnboarded);
                if (res.data.type === 1) {
                  localStorage.setItem("id", res.data.id);
                  // that.$refs.loading.close()
                  sessionStorage.setItem("user", res.data.email);
                  sessionStorage.setItem("userId", res.data.user_id);
                  sessionStorage.setItem("isAdmin", res.data.isAdmin);
                  sessionStorage.setItem("isLoggedIn", true);
                  // sessionStorage.setItem('isFirstTime', res.data.isFirstTime)
                  sessionStorage.setItem("status", true);
                  // that.SET_IS_SECURITY_QUESTION(res.data.ask_question)
                  localStorage.setItem(
                    "is_security_question",
                    res.data.ask_question
                  );
                  if (process.env.VUE_APP_NODE_TYPE === "development") {
                    that.$router.push("/");
                  }

                  if (process.env.VUE_APP_NODE_TYPE === "devment") {
                    window.location = "https://app.fexdrive.com";
                  }

                  if (process.env.VUE_APP_NODE_TYPE === "production") {
                    window.location = "https://app.fexspace.com";
                  }
                  return;
                }

                if (res.data.stage === 2) {
                  // cookies.setCookie('regtoken', res.data.token, 6 * 60 * 60 * 1000)
                  cookies.removeCookie(
                    "email",
                    res.data.email,
                    6 * 60 * 60 * 1000
                  );
                  cookies.removeCookie(
                    "name",
                    res.data.name,
                    6 * 60 * 60 * 1000
                  );
                  cookies.removeCookie(
                    "tran_ref",
                    res.data.tran_ref,
                    6 * 60 * 60 * 1000
                  );
                  that.$router.push("/setup-account");
                }

                if (res.data.stage === 6) {
                  if (process.env.VUE_APP_NODE_TYPE == "development") {
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    // window.location = 'http://192.168.1.2:3000/pricing-free-trial'
                    window.location = "http://192.168.1.2:3000/plans";
                  }

                  if (process.env.VUE_APP_NODE_TYPE == "devment") {
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    // window.location = 'http://fexdrive.com/pricing-free-trial'
                    window.location = "http://fexdrive.com/plans";
                  }

                  if (process.env.VUE_APP_NODE_TYPE == "production") {
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    // window.location = 'http://fexspace.com/pricing-free-trial'
                    window.location = "http://fexspace.com/plans";
                  }
                }

                if (res.data.stage === 7 || res.data.stage == null) {
                  if (process.env.VUE_APP_NODE_TYPE == "development") {
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    // window.location = 'http://192.168.1.2:3000/choose-plan'
                    window.location = "http://192.168.1.2:3000/plans";
                  }

                  if (process.env.VUE_APP_NODE_TYPE == "devment") {
                    cookies.setCookie(
                      "email",
                      res.data.email,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie(
                      "tran_ref",
                      res.data.tran_ref,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    // window.location = 'http://fexdrive.com/choose-plan'
                    window.location = "http://fexdrive.com/plans";
                  }

                  if (process.env.VUE_APP_NODE_TYPE == "production") {
                    cookies.setCookie(
                      "email",
                      res.data.email,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie(
                      "tran_ref",
                      res.data.tran_ref,
                      6 * 60 * 60 * 1000
                    );
                    cookies.setCookie(
                      "name",
                      res.data.name,
                      6 * 60 * 60 * 1000
                    );
                    // window.location = 'http://fexspace.com/choose-plan'
                    window.location = "http://fexspace.com/plans";
                  }
                }

                if (res.data.stage === 3) {
                  if (this.$route.query.redirect !== undefined) {
                    that.SET_IS_SECURITY_QUESTION(res.data.ask_question);
                    localStorage.setItem(
                      "is_security_question",
                      res.data.ask_question
                    );
                    sessionStorage.setItem("user", res.data.email);
                    sessionStorage.setItem("userId", res.data.user_id);
                    sessionStorage.setItem("isAdmin", res.data.isAdmin);
                    sessionStorage.setItem("isFirstTime", res.data.isFirstTime);
                    sessionStorage.setItem("isLoggedIn", true);
                    sessionStorage.setItem(
                      "redirect",
                      this.$route.query.redirect
                    );
                    that.$router.push("/authenticate");
                  }
                  // cookies.setCookie('token', res.data.token, 6 * 60 * 60 * 1000)
                  if (res.data.ask_question == true) {
                    sessionStorage.setItem("user", res.data.email);
                    sessionStorage.setItem("userId", res.data.user_id);
                    sessionStorage.setItem("isAdmin", res.data.isAdmin);
                    sessionStorage.setItem("isLoggedIn", true);
                    sessionStorage.setItem("isFirstTime", res.data.isFirstTime);
                    that.SET_IS_SECURITY_QUESTION(res.data.ask_question);
                    localStorage.setItem(
                      "is_security_question",
                      res.data.ask_question
                    );
                    that.$router.push("/authenticate");
                  } else {
                    localStorage.setItem("id", res.data.id);
                    // that.$refs.loading.close()
                    sessionStorage.setItem("user", res.data.email);
                    sessionStorage.setItem("userId", res.data.user_id);
                    sessionStorage.setItem("isAdmin", res.data.isAdmin);
                    sessionStorage.setItem("isLoggedIn", true);
                    sessionStorage.setItem("isFirstTime", res.data.isFirstTime);
                    sessionStorage.setItem("status", true);
                    that.SET_IS_SECURITY_QUESTION(res.data.ask_question);
                    localStorage.setItem(
                      "is_security_question",
                      res.data.ask_question
                    );
                    if (process.env.VUE_APP_NODE_TYPE === "development") {
                      that.$router.push("/");
                    }

                    if (process.env.VUE_APP_NODE_TYPE === "devment") {
                      window.location = "https://app.fexdrive.com";
                    }

                    if (process.env.VUE_APP_NODE_TYPE === "production") {
                      window.location = "https://app.fexspace.com";
                    }
                  }
                }

                if (res.data.stage === 5) {
                  let url = "";

                  if (res.data.type === 2) {
                    url = "personal-pro";
                  }

                  if (res.data.type === 3) {
                    url = "business";
                  }

                  if (res.data.type === 4) {
                    url = "business-plus";
                  }

                  cookies.setCookie(
                    "email",
                    res.data.email,
                    6 * 60 * 60 * 1000
                  );
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  cookies.setCookie(
                    "tran_ref",
                    res.data.tran_ref,
                    6 * 60 * 60 * 1000
                  );

                  if (process.env.VUE_APP_NODE_TYPE === "devment") {
                    window.location =
                      "http://fexdrive.com/complete-purchase/" + url;
                  }

                  if (process.env.VUE_APP_NODE_TYPE === "production") {
                    window.location =
                      "http://fexspace.com/complete-purchase/" + url;
                  }
                }
                // that.$refs.loading.close()
              } else {
                that.$refs.loading.close();
                that.error.message = true;
              }
            })
            .catch((err) => {
              console.log(err);
            });
        }
      }
    },
    submit() {
      this.post = true;

      if (this.email === "") {
        this.post = false;
        this.error.email = true;
      } else {
        this.error.email = false;
      }

      if (this.password === "") {
        this.post = false;
        this.error.password = true;
      } else {
        this.error.password = false;
      }

      if (this.post) {
        let that = this;
        this.$refs.loading.load();

        sessionStorage.setItem("keepme", this.keepme);

        let data = {
          email: this.email,
          password: this.password,
        };

        AuthenticationService.login(data)
          .then((res) => {
            if (res.data.data === true) {
              // If your plan type is 1. You are a free user
              localStorage.setItem("hasOnboarded", res.data.hasOnboarded);
              if (res.data.type === 1) {
                localStorage.setItem("id", res.data.id);
                // that.$refs.loading.close()
                sessionStorage.setItem("user", res.data.email);
                sessionStorage.setItem("userId", res.data.user_id);
                sessionStorage.setItem("isAdmin", res.data.isAdmin);
                sessionStorage.setItem("isLoggedIn", true);
                // sessionStorage.setItem('isFirstTime', res.data.isFirstTime)
                sessionStorage.setItem("status", true);
                // that.SET_IS_SECURITY_QUESTION(res.data.ask_question)
                localStorage.setItem(
                  "is_security_question",
                  res.data.ask_question
                );
                if (process.env.VUE_APP_NODE_TYPE === "development") {
                  that.$router.push("/");
                }

                if (process.env.VUE_APP_NODE_TYPE === "devment") {
                  window.location = "https://app.fexdrive.com";
                }

                if (process.env.VUE_APP_NODE_TYPE === "production") {
                  window.location = "https://app.fexspace.com";
                }
                return;
              }

              if (res.data.stage === 2) {
                // cookies.setCookie('regtoken', res.data.token, 6 * 60 * 60 * 1000)
                cookies.removeCookie(
                  "email",
                  res.data.email,
                  6 * 60 * 60 * 1000
                );
                cookies.removeCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                cookies.removeCookie(
                  "tran_ref",
                  res.data.tran_ref,
                  6 * 60 * 60 * 1000
                );
                that.$router.push("/setup-account");
              }

              if (res.data.stage === 6) {
                if (process.env.VUE_APP_NODE_TYPE == "development") {
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  // window.location = 'http://192.168.1.2:3000/pricing-free-trial'
                  window.location = "http://192.168.1.2:3000/plans";
                }

                if (process.env.VUE_APP_NODE_TYPE == "devment") {
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  // window.location = 'http://fexdrive.com/pricing-free-trial'
                  window.location = "http://fexdrive.com/plans";
                }

                if (process.env.VUE_APP_NODE_TYPE == "production") {
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  // window.location = 'http://fexspace.com/pricing-free-trial'
                  window.location = "http://fexspace.com/plans";
                }
              }

              if (res.data.stage === 7 || res.data.stage == null) {
                if (process.env.VUE_APP_NODE_TYPE == "development") {
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  // window.location = 'http://192.168.1.2:3000/choose-plan'
                  window.location = "http://192.168.1.2:3000/plans";
                }

                if (process.env.VUE_APP_NODE_TYPE == "devment") {
                  cookies.setCookie(
                    "email",
                    res.data.email,
                    6 * 60 * 60 * 1000
                  );
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  cookies.setCookie(
                    "tran_ref",
                    res.data.tran_ref,
                    6 * 60 * 60 * 1000
                  );
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  // window.location = 'http://fexdrive.com/choose-plan'
                  window.location = "http://fexdrive.com/plans";
                }

                if (process.env.VUE_APP_NODE_TYPE == "production") {
                  cookies.setCookie(
                    "email",
                    res.data.email,
                    6 * 60 * 60 * 1000
                  );
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  cookies.setCookie(
                    "tran_ref",
                    res.data.tran_ref,
                    6 * 60 * 60 * 1000
                  );
                  cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                  // window.location = 'http://fexspace.com/choose-plan'
                  window.location = "http://fexspace.com/plans";
                }
              }

              if (res.data.stage === 3) {
                if (this.$route.query.redirect !== undefined) {
                  that.SET_IS_SECURITY_QUESTION(res.data.ask_question);
                  localStorage.setItem(
                    "is_security_question",
                    res.data.ask_question
                  );
                  sessionStorage.setItem("user", res.data.email);
                  sessionStorage.setItem("userId", res.data.user_id);
                  sessionStorage.setItem("isAdmin", res.data.isAdmin);
                  sessionStorage.setItem("isFirstTime", res.data.isFirstTime);
                  sessionStorage.setItem("isLoggedIn", true);
                  sessionStorage.setItem(
                    "redirect",
                    this.$route.query.redirect
                  );
                  that.$router.push("/authenticate");
                }
                // cookies.setCookie('token', res.data.token, 6 * 60 * 60 * 1000)
                if (res.data.ask_question == true) {
                  sessionStorage.setItem("user", res.data.email);
                  sessionStorage.setItem("userId", res.data.user_id);
                  sessionStorage.setItem("isAdmin", res.data.isAdmin);
                  sessionStorage.setItem("isLoggedIn", true);
                  sessionStorage.setItem("isFirstTime", res.data.isFirstTime);
                  that.SET_IS_SECURITY_QUESTION(res.data.ask_question);
                  localStorage.setItem(
                    "is_security_question",
                    res.data.ask_question
                  );
                  that.$router.push("/authenticate");
                } else {
                  localStorage.setItem("id", res.data.id);
                  // that.$refs.loading.close()
                  sessionStorage.setItem("user", res.data.email);
                  sessionStorage.setItem("userId", res.data.user_id);
                  sessionStorage.setItem("isAdmin", res.data.isAdmin);
                  sessionStorage.setItem("isLoggedIn", true);
                  sessionStorage.setItem("isFirstTime", res.data.isFirstTime);
                  sessionStorage.setItem("status", true);
                  that.SET_IS_SECURITY_QUESTION(res.data.ask_question);
                  localStorage.setItem(
                    "is_security_question",
                    res.data.ask_question
                  );
                  if (process.env.VUE_APP_NODE_TYPE === "development") {
                    that.$router.push("/");
                  }

                  if (process.env.VUE_APP_NODE_TYPE === "devment") {
                    window.location = "https://app.fexdrive.com";
                  }

                  if (process.env.VUE_APP_NODE_TYPE === "production") {
                    window.location = "https://app.fexspace.com";
                  }
                }
              }

              if (res.data.stage === 5) {
                let url = "";

                if (res.data.type === 2) {
                  url = "personal-pro";
                }

                if (res.data.type === 3) {
                  url = "business";
                }

                if (res.data.type === 4) {
                  url = "business-plus";
                }

                cookies.setCookie("email", res.data.email, 6 * 60 * 60 * 1000);
                cookies.setCookie("name", res.data.name, 6 * 60 * 60 * 1000);
                cookies.setCookie(
                  "tran_ref",
                  res.data.tran_ref,
                  6 * 60 * 60 * 1000
                );

                if (process.env.VUE_APP_NODE_TYPE === "devment") {
                  window.location =
                    "http://fexdrive.com/complete-purchase/" + url;
                }

                if (process.env.VUE_APP_NODE_TYPE === "production") {
                  window.location =
                    "http://fexspace.com/complete-purchase/" + url;
                }
              }
              // that.$refs.loading.close()
            } else {
              that.$refs.loading.close();
              that.error.message = true;
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    isValidURL(string) {
      var res = string.match(
        /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g
      );
      return res !== null;
    },
  },
  created() {
    let externalScript = document.createElement("script");
    externalScript.setAttribute("src", "https://cdn.ywxi.net/js/1.js");
    externalScript.async = true;
    externalScript.defer = true;
    document.body.appendChild(externalScript);
  },
  mounted() {
    // if (this.$route.query.redirect !== undefined) {
    //   if (this.isValidURL(this.$route.query.redirect)) {
    //     cookies.setCookie('redirect', this.$route.query.redirect, 6 * 60 * 60 * 1000)
    //   } else {
    //     cookies.setCookie('redirect', this.$route.query.redirect, 0)
    //   }
    // }

    if (
      cookies.getCookie("contiune_email") !== "" &&
      cookies.getCookie("continue_email") !== null &&
      cookies.getCookie("continue_email") !== undefined
    ) {
      this.name = cookies.getCookie("continue_name");
      this.email = cookies.getCookie("continue_email");
    }

    localStorage.removeItem("current_directory_id");
    localStorage.removeItem("db");
    if (
      cookies.getCookie("token") !== "" &&
      cookies.getCookie("token") !== null
    ) {
      if (sessionStorage.getItem("status") === "true") {
        this.$router.push("/");
      }
    }

    this.SET_DIRECTORY_CHILDREN([]);
  },
};
</script>
